import { render, staticRenderFns } from "./MortgageDocumentsSendPopUp.vue?vue&type=template&id=2c60706e&scoped=true&"
import script from "./MortgageDocumentsSendPopUp.vue?vue&type=script&lang=js&"
export * from "./MortgageDocumentsSendPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c60706e",
  null
  
)

export default component.exports